$(".personalized-container").each(function() {
    var visitor_id;
    var container_id = $(this).data('uid');
    var child_id = $(this).data('child-uid');
    if ($('#matomoTracking').length) {
        _paq.push([function() {
            visitor_id = this.getVisitorId();
        }]);
    }

    // $.get("/index.php?id=" + $("#ttgVisitorContent").data('uid'), function(data) {
    //     $(data).find("#ttgRbContentWrapper .container").appendTo("#ttgVisitorContent");
    //     $("#ttgVisitorContent").fadeIn('slow');
    // });
    // console.log('%cTTG Debug - Visitor ID', 'background: #0080a3; color: #fff; padding: 5px;', visitor_id);
    if (visitor_id) {
        $.ajax({
            type: "POST",
            url: '/index.php?id=' + rootPage + '&type=654321&L=0',
            data: {
                visitor_id: visitor_id,
                container_id: container_id,
                child_id: child_id,
                page_id: $('body').data('pid'),
                incl_campaign: $(this).hasClass('incl_campaign'),
                excl_campaign: $(this).hasClass('excl_campaign'),
            },
            dataType: 'json',
            success: function(result) {
                if (result.showBanner == true) {
                    showBanner = true;
                    $.get('/index.php?id=' + $('body').data('pid') + '&type=6543211&childUid=' + child_id, function(data) {
                        $(data).filter('.ttgNCEContainer').appendTo("#ttgVisitorContent" + container_id);
                        $(data).filter('link').appendTo("head");
                        $("#ttgVisitorContent" + container_id).fadeIn('slow');
                        trackEvent('Context-Grid', $("#ttgVisitorContent" + container_id).data('name'), 'sichtbar');
                    }, 'text');
                }
            },
            error: function(xhr, status, error) {
                console.log('%cTTG Debug', 'background: #0080a3; color: #fff; padding: 5px;', status);
            }
        });

    } else if ($(this).hasClass('show-content')) {
        // wenn keine visitor-ID vorhanden ist (Analyse Cookies nicht zugestimmt) und nur eine Exclude Kampagen hinterlegt ist, wird der Container angezeigt
        $.get('/index.php?id=' + $('body').data('pid') + '&type=6543211&childUid=' + child_id, function(data) {
            $(data).filter('.ttgNCEContainer').appendTo("#ttgVisitorContent" + container_id);
            $(data).filter('link').appendTo("head");
            $("#ttgVisitorContent" + container_id).fadeIn('slow');
            trackEvent('Context-Grid', $("#ttgVisitorContent" + container_id).data('name'), 'sichtbar');
        }, 'text');
    }

    $("#ttgVisitorContent" + container_id + " .close-matomo-banner").on("click", function() {
        $("#ttgVisitorContent" + container_id).fadeOut('slow');
        trackEvent('Context-Grid', $("#ttgVisitorContent" + container_id).data('name'), 'deaktiviert');
    });

    $("#ttgVisitorContent" + container_id + " div.ttgNCEContainer").on("click", function() {
        trackEvent('Context-Grid', $("#ttgVisitorContent" + container_id).data('name'), 'Klick');
    });
});
